module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_02-75f5c1f3cd4e5dd227054f37cc3f1f03.png";